import React from "react";
import { Field, Select } from "@conserveit/blocks";
import PropTypes from "prop-types";
import { REPORT_OPTIONS } from "./ReportSelect.config";

const ReportSelect = ({ selected, disabled, onChange }) => (
  <Field
    label="Report"
    name="select-report"
    help="NOTE: These reports may not be available for all projects and sites."
  >
    {({ error, name, id }) => (
      <Select
        clearable={false}
        name={name}
        error={error}
        id={id}
        value={selected}
        disabled={disabled}
        onChange={onChange}
        options={REPORT_OPTIONS}
      />
    )}
  </Field>
);

ReportSelect.defaultProps = {
  selected: null,
};

ReportSelect.propTypes = {
  selected: PropTypes.object,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ReportSelect;
